export default class ChargeCountManager {
  constructor() {
  }

  // 窗口宽度
  static WINDOW_WIDTH = 280;

  // 窗口高度
  static WINDOW_HEIGHT = 165;

  // 状态:隐藏窗口
  static STATE_HIDE = 'hidePop';

  // 状态:显示窗口
  static STATE_DISP = 'dispPop';

  // 在弹窗的group显示
  static DISP_IN_GRID = true;

  // 在group bar中显示
  static DISP_IN_GROUP = false;
}
